import { IDatasetTypeMetadata } from 'app/extensibility/metadatas/resource-type/dataset-type-metadata';

import { writeBehaviorAllOptions, writeBehaviorOptionValues } from 'app/shared/constants/write-behavior.const';
import { Constants } from 'app/shared/shared-constants';
import { format } from 'app/shared/utils/string.util';
import { disableMetricsCollectionCheckboxMetadata, maxConcurrentConnectionsMetadata } from '../consts/metadata-consts';
import { adfModelTypeMap } from '../consts/adf-model-type-map-const';
import { azureRegionOptions } from 'app/shared/constants/azure-region.const';
import { getAppendOption, getUpsertOption } from 'app/registries/consts/copy-job-const';
import { UpdateMethod } from 'shell-models-lib';

const comosSinkWriteBehaviors = [writeBehaviorOptionValues.insert, writeBehaviorOptionValues.upsert];
export const cosmosDbCollectionMetadata: IDatasetTypeMetadata = {
    type: adfModelTypeMap.cosmosSql.datasetType,
    displayName: stringResources.CosmosDb_DisplayText,
    supportLinkedServiceTypes: [adfModelTypeMap.cosmosSql.linkedServiceType],
    isSource: true,
    isSink: true,
    datasetKind: 'hierarchical',
    notSupportTypeConversion: true,
    icon: {
        className: 'svg-i-100x100-AzureCosmosDB'
    },
    tableNameDisplay: stringResources.ModelName_Container,
    tableNamePlural: stringResources.ModelName_Containers,
    datasetNamePrefix: 'CosmosDbNoSqlContainer',
    isFirstClass: true,
    isTableNameRequired: true,
    category: ['Azure'],
    supportCreatedAsV2: true,
    supportDataFlowSource: true,
    supportDataFlowSink: true,
    supportDataFlowWriteComplexStructure: true,
    copySourceControls: [
        {
            type: 'parameterizable',
            child: {
                type: 'textbox-number',
                bind: 'pageSize',
                isLabelVertical: false,
                label: stringResources.PageSizeLabel,
                description: stringResources.AzureCosmos_PageSizeDescription
            },
            dynamicContentTextClass: 'input-spaced'
        },
        {
            type: 'parameterizable',
            child: {
                type: 'checkbox',
                bind: 'detectDatetime',
                label: stringResources.DetectDateTimeLabel,
                defaultValue: true,
                isLabelVertical: false
            },
            dynamicContentTextClass: 'input-spaced'
        },
        {
            type: 'parameterizable',
            child: {
                type: 'array-container',
                bind: 'preferredRegions',
                label: stringResources.ModelName_Preferred_Regions,
                isLabelVertical: false,
                expandable: false,
                child: {
                    type: 'array-item',
                    children: [
                        {
                            type: 'select',
                            bind: 'itemPropertyNamePlaceholder',
                            editable: true,
                            options: azureRegionOptions
                        }
                    ]
                }
            },
            dynamicContentTextClass: 'input-spaced'
        }
    ],
    copySinkControls: [
        {
            type: 'parameterizable-dropdown',
            bind: 'writeBehavior',
            label: stringResources.ModelName_WriteBehavior,
            isLabelVertical: false,
            options: writeBehaviorAllOptions.filter((option) => comosSinkWriteBehaviors.indexOf(option.value) >= 0)
        },
        {
            type: 'parameterizable',
            child: {
                type: 'textbox',
                bind: 'writeBatchTimeout',
                label: stringResources.ModelName_WriteBatchTimeout,
                validators: [
                    {
                        type: 'pattern',
                        pattern: Constants.timeoutValidationPattern,
                        errorMessage: format(
                            stringResources.InvalidTimeoutPattern,
                            stringResources.ModelName_WriteBatchTimeout
                        )
                    }
                ]
            },
            dynamicContentTextClass: 'input-spaced'
        },
        {
            type: 'parameterizable',
            child: {
                type: 'textbox-number',
                bind: 'writeBatchSize',
                label: stringResources.ModelName_WriteBatchSize,
                inputType: 'number',
                min: 0
            },
            dynamicContentTextClass: 'input-spaced'
        },
        maxConcurrentConnectionsMetadata,
        disableMetricsCollectionCheckboxMetadata
    ],
    copyJob: {
        updateMethod: {
            supportUpdateMethod: true,
            options: [getAppendOption(), getUpsertOption()],
            updateMethodProperties: ['writeBehavior'],
            defaultUpdateMethod: UpdateMethod.Append,
            noUpsertKeyColumn: true
        }
    }
};
